var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header',[_vm._v(_vm._s(_vm.label))]),_c('v-row',_vm._l((_vm.options),function(item,index){return _c('v-col',{key:index,class:_vm.colclass},[_c('v-checkbox',{attrs:{"name":_vm.name,"label":item,"value":item},on:{"change":function($event){return _vm.updatecheckbox(_vm.name, $event, item)}}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }